/**
 * @generated SignedSource<<6ae5a2a5c2afd70737ed86c96ec726f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
import { FragmentRefs } from "relay-runtime";
export type MergeStream_StreamIntegration$data = {
  readonly actionItemIntegration: {
    readonly integrationProvider: IntegrationProvider;
  } | null;
  readonly asanaStream: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "MergeStream_StreamIntegration";
};
export type MergeStream_StreamIntegration$key = {
  readonly " $data"?: MergeStream_StreamIntegration$data;
  readonly " $fragmentSpreads": FragmentRefs<"MergeStream_StreamIntegration">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "MergeStream_StreamIntegration"
};

(node as any).hash = "1b871e62d3bb6476c1b693d910c5cfef";

export default node;
